export default "__VITE_ASSET__CKvc7cT$__"